/**
 * Client for adk-be-app's usage/activity dashboard endpoint (task #212,
 * src/routes/usage.py). Sessions/messages/tokens totals, streaks, and a
 * per-day series computed directly from ADK's own Postgres tables — see
 * that route's own docstring for exactly what counts as a "message" and
 * why there's no per-project breakdown yet (a per-user "my activity"
 * view is what this first cut covers).
 */

import config from '../config';
import { getAuthorizedFetch } from '../utils/fetchRegistry';
import { buildAclContextHeaders } from '../utils/aclContext';

/**
 * @param {string} userId
 * @returns {Promise<{
 *   totalSessions: number,
 *   totalMessages: number,
 *   totalInputTokens: number,
 *   totalOutputTokens: number,
 *   totalTokens: number,
 *   currentStreakDays: number,
 *   longestStreakDays: number,
 *   dailyActivity: Array<{day: string, messages: number, tokens: number}>,
 * }>}
 */
export async function getUsageSummary(userId) {
  const base = (config.vfsAgentUrl || '').replace(/\/+$/, '');
  const response = await getAuthorizedFetch()(`${base}/api/usage/${encodeURIComponent(userId)}`, {
    headers: { Accept: 'application/json', ...buildAclContextHeaders() },
  });
  if (!response.ok) {
    throw new Error(`Failed to load usage summary (${response.status})`);
  }
  return response.json();
}
